import { getCurrentInstance } from '@vue/composition-api';
import { eventTracker } from 'partners-widget-core';

const useModalHandlers = () => {
  const { emit } = getCurrentInstance();

  const setOpenMenu = () => {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    window.dataLayer.open_menu = true;
    eventTracker.dispatchEvent('city-select-open');
  };

  const removeOpenMenu = () => {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    window.dataLayer.open_menu = false;
    eventTracker.dispatchEvent('city-select-close');
  };

  const getScrollbarSize = () => {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    outer.style.msOverflowStyle = 'scrollbar';

    document.body.appendChild(outer);

    const widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = 'scroll';

    // add inner div
    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode.removeChild(outer);

    return widthNoScroll - widthWithScroll;
  };

  const blockScroll = () => {
    document.body.style.width = `calc(100% - ${getScrollbarSize()}px)`;
  };

  const unlockScroll = () => {
    document.body.style.width = '';
  };

  const setBlockScroll = () => {
    blockScroll();
    document.body.style.overflow = 'hidden';
  };

  const setUnlockScroll = () => {
    unlockScroll();
    document.body.style.overflow = '';
  };

  const handlerBeforeOpen = (event) => {
    emit('before-open', event);
    blockScroll();
    // запрещаем рекламе показываться
    setOpenMenu();
  };

  const handlerBeforeClose = (event) => {
    emit('before-close', event);
    emit('close-search');
    unlockScroll();
    // разрешаем рекламе показываться
    removeOpenMenu();
  };

  const handlerOpened = (event) => {
    emit('opened', event);
  };

  const handlerClosed = (event) => {
    emit('closed', event);
  };

  return {
    handlerBeforeOpen,
    handlerBeforeClose,
    handlerOpened,
    handlerClosed,
    blockScroll,
    unlockScroll,
    setBlockScroll,
    setUnlockScroll,
  };
};

export default useModalHandlers;
